export const croTypeNames = [
  'client relations officer',
  'client relations associate',
  'client relation officer',
  'associate academic mentor',
];
export const ogaTypeNames = [
  'operations growth associate',
  'operations growth trainee',
  'operations growth associate trainee',
];

export const crmTypes = ['client relations manager', 'senior client relations officer', 'senior program officer'];

export const sogoTypes = ['senior operations growth officer'];
